<div #modal class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button id='memberDevicesModalDialogClose' type="button" class="close" data-dismiss="modal"
          aria-label="Close"><span aria-hidden="true">&times;</span></button>
        <h2 class="modal-title">Tokens</h2>
      </div>
      <div class="modal-body">
        <div class="table-responsive">
          <div class="loading-cont" *ngIf="loading">
            <div class="loading-spinner"></div>
          </div>

          <p class="no-items-found" *ngIf="!loading && devices.length === 0">
            No devices found.
          </p>

          <table class="table table-hover" *ngIf="!loading && devices.length > 0">
            <thead>
              <tr>
                <th>
                  <span class="col-name">Token</span>
                </th>
                <th>
                  <span class="col-name">Platform</span>
                </th>
                <th>
                  <span class="col-name">App Version</span>
                </th>
                <th>
                  <span class="col-name">Installation ID</span>
                </th>
                <th>
                  <span class="col-name">Created</span>
                </th>
                <th>
                  <span class="col-name">Updated</span>
                </th>
                <th>
                  <span class="col-name">Status</span>
                </th>
                <th>
                  <span class="col-name">Location known</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let device of devices">
                <td>
                  <code>{{ device.token }}</code>
                </td>
                <td>
                  <span>{{ device.platform }}</span>
                </td>
                <td>
                  <span>{{ device.appVersion }}</span>
                </td>
                <td>
                  <code>{{ device.installationId }}</code>
                </td>
                <td>
                  <span>{{ device.createdAt | dateFormat: "datetime" }}</span>
                </td>
                <td>
                  <span>{{ device.updatedAt | dateFormat: "datetime" }}</span>
                </td>
                <td>
                  <span *ngIf="device.isValid" class="label label-success">Valid</span>
                  <span *ngIf="!device.isValid" class="label label-danger">Invalid</span>
                </td>
                <td>
                  <span *ngIf="device.isLocationKnown" class="label label-success">Known</span>
                  <span *ngIf="!device.isLocationKnown" class="label label-default">Unknown</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class='modal-actions'>
        <button id='memberDevicesModalDialogOK' type="button" data-dismiss="modal" class="btn btn-info">OK</button>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/member/devices-modal-dialog/devices-modal-dialog.component.html